// extracted by mini-css-extract-plugin
export default {"banner":"Showcase_banner__IbnAe","image":"Showcase_image__tpU8O","backBtn":"Showcase_backBtn__zioaY","nextBtn":"Showcase_nextBtn__X5Aej","App":"Showcase_App__Ha-Wr"};